var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChanelLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 28,
    viewBox: "0 0 180 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5091_5229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.695 27.1976V21.998H137.697V15.9986H149.696V10.799H137.697V5.99946H151.496V0.599946H132.297V27.1976H152.695ZM160.295 0.599946V27.1976H179.693V21.998H165.694V0.599946H160.295ZM33.506 0.599946V27.1976H38.9055V15.9986H51.5044V27.1976H56.7048V0.599946H51.5044V10.799H38.9055V0.599946H33.506ZM87.3012 27.1976H93.1007L80.9018 0.599946H73.9024L61.9035 27.1976H67.5038L70.3027 21.1981H84.5023L87.3012 27.1976ZM98.3011 0.599946V27.1976H103.701V7.99929L118.099 27.1976H122.298V0.599946H116.899V16.5985L104.901 0.599946H98.3011ZM21.907 18.1984C21.183 19.5874 20.0913 20.7509 18.7513 21.562C17.4112 22.3731 15.8741 22.8006 14.3077 22.798C9.46481 22.7938 5.55682 18.8866 5.50849 13.9987C5.55682 9.24667 9.46481 5.33869 14.3077 5.39952C17.5982 5.33869 20.4813 7.18603 21.907 9.99911L26.7066 7.39934C24.2468 3.00557 19.6131 0.0358301 14.3077 0C6.53673 0.0358301 0.25479 6.31777 0.308952 13.9987C0.253957 21.8156 6.5359 28.0967 14.3077 27.9975C19.6272 28.0967 24.2718 25.1111 26.7066 20.7981L21.907 18.1984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3023 15.7986H72.7031L77.5036 5.19952L82.3023 15.7986Z",
    fill: "#956B47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5091_5229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179.487,
    height: 28,
    fill: "white",
    transform: "translate(0.257812)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChanelLogo);
export default __webpack_public_path__ + "static/media/chanelLogo.25583326c89cb73009f08bfc9cb69955.svg";
export { ForwardRef as ReactComponent };